import { Flex, Typography } from 'antd'
import { Select } from '@/shared/ui/components/Select'
import { Icon } from '@/shared/ui/Icon/Icon'
import { Checkbox } from '@/shared/ui/components/Checkbox'
import { useBreakpoint } from '@/app/hooks/useBreakpoint'

const { Text } = Typography
const { Option } = Select

interface Props {
  loadMessages?: boolean
  messagePeriod?: number
  onMessagePeriodChange?: (period: number) => void
  onLoadMessagesChange?: (checked: boolean) => void
}

export const MessagePeriodSelect = ({
  loadMessages,
  messagePeriod,
  onMessagePeriodChange,
  onLoadMessagesChange,
}: Props) => {
  const { isSm, isXs } = useBreakpoint()
  const isMobile = isXs || isSm

  return (
    <Flex gap={8} vertical={isMobile}>
      <Checkbox
        checked={loadMessages}
        onChange={(e) => onLoadMessagesChange?.(e.target.checked)}
      >
        <Text strong>Загружать сообщения</Text>
      </Checkbox>
      <Flex vertical gap={4}>
        <Select
          disabled={!loadMessages}
          value={messagePeriod}
          onChange={onMessagePeriodChange}
          suffixIcon={<Icon name="drop_arrow" size={16} />}
          style={{ width: 214 }}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children ?? '')
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          styles={{
            popup: {
              root: {
                maxHeight: 300,
                overflow: 'auto',
              },
            },
          }}
        >
          {Array.from({ length: 365 }, (_, i) => i + 1).map((days) => (
            <Option key={days} value={days}>
              {days}
            </Option>
          ))}
        </Select>
        <Text style={{ fontSize: '12px' }} type="secondary">
          Период загрузки сообщений (дней)
        </Text>
      </Flex>
    </Flex>
  )
}
